module.exports = __webpack_public_path__ + "static/media/prv8.d9633a6b.jpg";